/**
 * @param {string} key 
 * @param {string|number} value 
 * @return {void}
 */
export const setItemLocalStorage = (key, value) => {
  if (!value || typeof value === undefined) {
    localStorage.removeItem(key)
    return
  }
  localStorage.setItem(key, value)
}

/**
 * @param {string} key 
 * @return {string|null}
 */
export const getItemLocalStorage = (key) => {
  return localStorage.getItem(key) ?? null
}

/**
 * @param {string} key 
 * @return {object|array|null} 
 */
export const getParsedItemLocalStorage = (key) => {
  const lsItem = getItemLocalStorage(key)
  return lsItem ? JSON.parse(lsItem) : null
}

/**
 * @param {string} key 
 * @return {void}
 */
export const removeItemLocalStorage = (key) => {
  localStorage.removeItem(key)
}